export const environment = {
    baseUrlBI: "http://www.lineaback.somee.com"//"https://soluciones.linea.pe/aplicativos/api_lineaBI",
};
